import { LinkListItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { CMSLink } from '@modules/Nzo.CMS/Frontend/libraries/shared/cmsLink/cmsLink.state'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { Link } from '@shared/Frontend/utils/link'
import { SVGIcon } from '@shared/Frontend/utils/svg'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const LinkListBlock: BlocksView['LinkListBlock'] = (props) => {
  const { id, items } = props
  if (items?.length == 0) return <></>

  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section id={id} ref={ref} className={cn('block block--linklist ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter gridsys--columns">
        <BlockHeader {...props} headerClassName='gridsys--50p' />

        <div className="block__content gridsys--50p">
          <ListLayout items={items} listClassName="block__list" />
          <BlockActions {...props} datalayerCategory="linklist_block" />
        </div>
      </div>
    </section>
  )
}

export const ListLayout = (props: { items: LinkListItem[]; listClassName?: string }) => {
  return (
    <ul className={cn('list', props.listClassName)}>
      {props.items.map((item, index) => {
        if (!item.link || !item.link.label || !item.link.url) return <></>
        return <ItemLayout key={index} {...item.link} subTitle={item.subTitle} />
      })}
    </ul>
  )
}

const ItemLayout = (props: { subTitle?: string } & CMSLink) => {
  const { subTitle, ...link } = props
  const { label, external } = link
  return (
    <li className="list__item">
      <Link
        {...link}
        className="list__link"
        onClick={() => pushDatalayer({ category: 'linklist_item', label, action: 'linklist_item_click' })}
      >
        <div className="list__text">
          {label && <p className="list__title title--xs">{label}</p>}
          {subTitle && <p className="list__description text--md">{subTitle}</p>}
          <SVGIcon className="list__icon" id={external ? 'icon-arrow-up-right' : 'icon-arrow-right'} size={24} />
        </div>
      </Link>
    </li>
  )
}
